import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  isEvbSameDay,
  isExtendedButNotSecondCar,
  isHasNotEvb,
  isNoExtendedCar,
  isNotEvbVisible,
  isNoVorversicherung,
  isVorfahrzeugNotAbgemeldet,
} from '@/features/Sparten/shared/contractDehydration/kfz/conditionalRequestDefinitions';

export const kfzContractDehydrationDefinitions: ConditionalRequestDefinition[] =
  [
    isNoExtendedCar,
    isExtendedButNotSecondCar,
    isNotEvbVisible,
    isHasNotEvb,
    isEvbSameDay,
    isNoVorversicherung,
    isVorfahrzeugNotAbgemeldet,
  ];
